import type { TipoDeCadastro } from './tipos';

/**
 * A chave do rascunho do formulario: empresa, pessoa, cadastro e registro. Sem
 * sessao, nao ha de quem guardar.
 */
export function chaveDoRascunhoDoCadastro(
  tipo: TipoDeCadastro,
  linhaId: string | null,
  sessao: { readonly empresa: string; readonly usuarioId: string } | null,
): string {
  return `cadastro:${tipo}:${linhaId ?? 'novo'}:${sessao?.empresa ?? 'sem-empresa'}:${sessao?.usuarioId ?? 'sem-sessao'}`;
}

/** Gravou: o rascunho daquele formulario sai, e nao volta na proxima abertura. */
export function esquecerRascunhoDoCadastro(chave: string): void {
  try {
    window.localStorage.removeItem(`ct-frotas:rascunho:${chave}`);
  } catch {
    /* Armazenamento bloqueado: nao havia rascunho para esquecer. */
  }
}
